import { ErrorMessage } from '@hookform/error-message';
import Image from 'next/image';
import { useState } from 'react';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import Input from '@/components/Input';

type FormData = {
  email: string;
  password: string;
};

interface LoginPasswordInputProps {
  register: UseFormRegister<FormData>;
  errors: FieldErrors<FormData>;
}

export const LoginPasswordInput = ({ register, errors }: LoginPasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        {...register('password', { required: true })}
        inputStyle="rounded"
        placeholder="Password"
        type={showPassword ? 'text' : 'password'}
        data-testid="passwordInput"
        autoComplete="current-password"
      />
      <button type="button" onClick={() => setShowPassword((prev) => !prev)}>
        <Image
          src={showPassword ? '/icons/eye-closed.svg' : '/icons/eye-open.svg'}
          alt="show password"
          height={15}
          width={20}
          className="absolute right-4 top-[36%] -translate-y-1/2"
        />
      </button>
      {errors.password && errors.password.type === 'required' && (
        <div className="error" role="alert">
          Password is required
        </div>
      )}
      <ErrorMessage
        errors={errors}
        name="password"
        render={({ message }) => <div className="error">{message}</div>}
      />
    </div>
  );
};
